import React from 'react';
import { Head } from '@inertiajs/react';
import SupplierForm from './Form';

interface Props {
  errors?: Record<string, string>;
}

export default function New({ errors }: Props) {
  return (
    <>
      <Head title="New Supplier" />

      <div className="py-12">
        <div className="max-w-7xl mx-auto sm:px-6 lg:px-8">
          <div className="bg-white overflow-hidden shadow-sm sm:rounded-lg">
            <div className="p-6 text-gray-900">
              <h1 className="text-2xl font-semibold mb-6">New Supplier</h1>
              <SupplierForm errors={errors} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
